import React from "react";
import { Plus, Trash2, Edit3, Image as ImageIcon } from "lucide-react";
import { useT, useLocalized } from "@/lib/LanguageContext";

export default function BlogList({ posts, onEdit, onDelete, onNew }) {
  const t = useT("admin");
  const loc = useLocalized();
  return (
    <>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-4xl text-eh-ink">{t("blog.title")}</h1>
          <p className="text-eh-muted mt-1">{t("blog.subtitle")}</p>
        </div>
        <button onClick={onNew} data-testid="admin-blog-new" className="btn-primary text-sm">
          <Plus size={16} /> {t("blog.new")}
        </button>
      </div>

      <div className="mt-8 space-y-3" data-testid="admin-blog-list">
        {posts.length === 0 && (
          <div className="text-eh-muted text-sm bg-eh-cream border border-eh-border-soft rounded-2xl p-8 text-center">
            {t("blog.empty")}
          </div>
        )}
        {posts.map((p) => (
          <div key={p.id} className="bg-eh-cream border border-eh-border-soft rounded-2xl p-5 flex items-center gap-5">
            <div className="w-16 h-16 rounded-xl bg-eh-bg overflow-hidden shrink-0 flex items-center justify-center">
              {p.cover_url ? (
                <img src={p.cover_url} alt="" className="w-full h-full object-cover" />
              ) : (
                <ImageIcon size={20} className="text-eh-muted" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className={`text-xs px-2 py-0.5 rounded-full ${p.published ? "bg-eh-sage/30 text-eh-sage-deep" : "bg-eh-border-soft text-eh-muted"}`}>
                  {p.published ? t("blog.published") : t("blog.draft")}
                </span>
                {loc(p, "tag") && <span className="text-xs text-eh-muted">{loc(p, "tag")}</span>}
              </div>
              <div className="font-display text-xl text-eh-ink truncate">{loc(p, "title") || t("blog.untitled")}</div>
              <div className="text-xs text-eh-muted truncate">/{p.slug}</div>
            </div>
            <button onClick={() => onEdit(p)} className="p-2 rounded-full hover:bg-eh-bg" data-testid={`admin-blog-edit-${p.id}`}>
              <Edit3 size={16} />
            </button>
            <button onClick={() => onDelete(p)} className="p-2 rounded-full hover:bg-red-50 text-red-600" data-testid={`admin-blog-delete-${p.id}`}>
              <Trash2 size={16} />
            </button>
          </div>
        ))}
      </div>
    </>
  );
}
